// import React, { useEffect, useState } from 'react'
// import Papa from "papaparse";
// function UploadStock() {
//   const [filesData,setFilesData]=useState([]);
//   const[selectedFile,setSelectedFile]=useState("");

//   useEffect(()=>{
//     const savedFiles=localStorage.getItem("csvFilesData");
//     if(savedFiles){
//       setFilesData(JSON.parse(savedFiles));
//     }
//   },[])
// useEffect(()=>{
//   if(filesData.length>0){
//     localStorage.setItem("csvFilesData",JSON.stringify(filesData));
//   }
// },[filesData])

// const handleFileChange=(e)=>{
// const file=e.target.files[0];
// if(!file) return

// Papa.parse(file,{
//   header:true,
//   skipEmptyLines:true,
//   complete:function(results){
//     const headers=Object.keys(results.data[0]);
//     const newFile={
//       id:Date.now(),
//       fileName:file.name,
//       headers,
//       tableData:results.data,
//       submitted:false,
//       editRowIndex:null,
//       editRowData:{},
//       uploadDate:new Date().toISOString().split('T')[0],
//     };
//     setFilesData((prev)=>[...prev,newFile])
//   }
// })
// e.target.value="";
// }

// const updateFileData=(id,updatedFields)=>{
//   setFilesData((prev)=>
//     prev.map((file)=>
//       file.id===id?{...file,...updatedFields}:file
//   ))

// }

// const handleEditClick=()=>{
//   const file=filesData.find((f)=>f.id===fileId);

// }
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default UploadStock
// import React, { useState } from 'react';
// import axios from 'axios';
// import { useSnackbar } from 'notistack';

// const UploadStock = () => {
//   const [file, setFile] = useState(null);
//   const { enqueueSnackbar } = useSnackbar();

//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     setFile(selected);
//   };

//   const handleCancel = () => {
//     setFile(null);
//   };

// //   const handleSubmit = async () => {
// //     if (!file) {
// //       enqueueSnackbar("Please select a file first.", { variant: "warning" });
// //       return;
// //     }

// //     const user = JSON.parse(localStorage.getItem("user"));
// //     const token = user?.token;

// //     if (!token) {
// //       enqueueSnackbar("User not authenticated. Please login.", { variant: "error" });
// //       return;
// //     }

// //     const formData = new FormData();
// //     formData.append("file", file);

// //     try {
// //       const res = await axios.post(
// //         `${process.env.REACT_APP_BASE_URL}stock/upload`,
// //         formData,
// //         {
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //             'Content-Type': 'multipart/form-data',
// //           },
// //         }
// //       );

// //       enqueueSnackbar("File uploaded successfully.", { variant: "success" });
// //       console.log("Response data:", res.data);
// //       setFile(null); // Clear file after success
// //     } catch (err) {
// //       console.error("Upload failed:", err);
// //       const message =
// //         err.response?.data?.message || "Something went wrong during upload.";
// //       enqueueSnackbar(message, { variant: "error" });
// //     }
// //   };
// const handleSubmit = async () => {
//   if (!file) {
//     enqueueSnackbar("Please select a file first.", { variant: "warning" });
//     return;
//   }

//   const user = JSON.parse(localStorage.getItem("user"));
//   const token = user?.token;

//   if (!token) {
//     enqueueSnackbar("User not authenticated. Please login.", { variant: "error" });
//     return;
//   }

//   const formData = new FormData();
//   formData.append("file", file);

//   try {
//     const res = await axios.post(
//       `${process.env.REACT_APP_BASE_URL}stock/upload`,
//       formData,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'multipart/form-data',
//         },
//       }
//     );

//     const message = res.data?.message;

//     if (message === "Excel file processed successfully") {
//       enqueueSnackbar("✅ Excel file uploaded and processed successfully!", {
//         variant: "success",
//       });
//       console.log("Uploaded Data:", res.data.data);
//     } else {
//       enqueueSnackbar(message || "File uploaded successfully.", { variant: "info" });
//     }

//     setFile(null);
//   } catch (err) {
//     console.error("Upload failed:", err);

//     const statusCode = err.response?.status;
//     const message = err.response?.data?.message;

//     if (statusCode === 400 && message?.includes("Duplicate entry")) {
//       enqueueSnackbar(`❌ ${message}`, { variant: "error" });
//     } else {
//       enqueueSnackbar(
//         message || "Something went wrong during upload.",
//         { variant: "error" }
//       );
//     }
//   }
// };



//   return (
//     <div className="p-6 max-w-md mx-auto bg-white rounded-xl shadow-md space-y-4 mt-10 border border-gray-300">
//       <h2 className="text-lg font-semibold text-center">Upload Excel File</h2>

//       <input
//         type="file"
//         accept=".xlsx,.xls"
//         onChange={handleFileChange}
//         className="block w-full text-sm text-gray-700 file:mr-4 file:py-1 file:px-3 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#2dbfa8] file:text-white hover:file:bg-[#25a895]"
//       />

//       {file && (
//         <div className="flex justify-between items-center border px-3 py-2 rounded-md bg-gray-50">
//           <span className="text-sm text-gray-800 truncate">{file.name}</span>
//           <div className="flex gap-2">
//             <button
//               onClick={handleSubmit}
//               className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm"
//             >
//               Submit
//             </button>
//             <button
//               onClick={handleCancel}
//               className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UploadStock;
// import React, { useState } from 'react';
// import axios from 'axios';

// const UploadExcel = () => {
//   const [file, setFile] = useState(null);
//   const [message, setMessage] = useState("");
//   const [messageType, setMessageType] = useState(""); // 'success' or 'error'

//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     setFile(selected);
//     setMessage("");
//     setMessageType("");
//   };

//   const handleCancel = () => {
//     setFile(null);
//     setMessage("");
//     setMessageType("");
//   };

//   const handleSubmit = async () => {
//     if (!file) {
//       setMessage("Please select a file first.");
//       setMessageType("error");
//       return;
//     }

//     const user = JSON.parse(localStorage.getItem("user"));
//     const token = user?.token;

//     if (!token) {
//       setMessage("User not authenticated. Please login.");
//       setMessageType("error");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}stock/upload`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'multipart/form-data',
//           },
//         }
//       );

//       setMessage("File uploaded successfully.");
//       setMessageType("success");
//       setFile(null);
//     } catch (err) {
//       // Extract correct message from response
//       const serverMessage =
//         err?.response?.data?.message ||
//         err?.response?.data?.error ||
//         err?.message ||
//         "Upload failed.";
        
//       setMessage(serverMessage);
//       setMessageType("error");
//     }
//   };

//   return (
//     <div className="p-6 max-w-md mx-auto bg-white rounded-xl shadow-md space-y-4 mt-10 border border-gray-300">
//       <h2 className="text-lg font-semibold text-center">Upload Excel File</h2>

//       {message && (
//         <div
//           className={`px-4 py-2 rounded text-sm ${
//             messageType === "success"
//               ? "bg-green-100 text-green-800"
//               : "bg-red-100 text-red-800"
//           }`}
//         >
//           {message}
//         </div>
//       )}

//       <input
//         type="file"
//         accept=".xlsx,.xls"
//         onChange={handleFileChange}
//         className="block w-full text-sm text-gray-700 file:mr-4 file:py-1 file:px-3 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#2dbfa8] file:text-white hover:file:bg-[#25a895]"
//       />

//       {file && (
//         <div className="flex justify-between items-center border px-3 py-2 rounded-md bg-gray-50">
//           <span className="text-sm text-gray-800 truncate">{file.name}</span>
//           <div className="flex gap-2">
//             <button
//               onClick={handleSubmit}
//               className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm"
//             >
//               Submit
//             </button>
//             <button
//               onClick={handleCancel}
//               className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UploadExcel;
// import React, { useState } from 'react';
// import { CloudUpload, XCircle } from 'lucide-react';
// import axios from 'axios';

// const UploadExcel = () => {
//   const [file, setFile] = useState(null);
//   const [message, setMessage] = useState('');
//   const [messageType, setMessageType] = useState('');

//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     setFile(selected);
//     setMessage('');
//     setMessageType('');
//   };

//   const handleCancel = () => {
//     setFile(null);
//     setMessage('');
//     setMessageType('');
//   };

//   const handleSubmit = async () => {
//     if (!file) {
//       setMessage('Please select a file first.');
//       setMessageType('error');
//       return;
//     }

//     const user = JSON.parse(localStorage.getItem('user'));
//     const token = user?.token;

//     if (!token) {
//       setMessage('User not authenticated. Please login.');
//       setMessageType('error');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', file);

//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}stock/upload`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'multipart/form-data',
//           },
//         }
//       );

//       setMessage('File uploaded successfully.');
//       setMessageType('success');
//       setFile(null);
//     } catch (err) {
//       const serverMessage =
//         err?.response?.data?.message ||
//         err?.response?.data?.error ||
//         err?.message ||
//         'Upload failed.';
//       setMessage(serverMessage);
//       setMessageType('error');
//     }
//   };



// return (
//   <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 py-16">
//     <div className="w-full max-w-xl bg-white shadow-2xl rounded-2xl p-10 space-y-6 border border-gray-300">
//       <h2 className="text-3xl font-bold text-center text-blue-900">
//         Upload Stock
//       </h2>

//       {message && (
//         <div
//           className={`p-3 rounded-md text-sm text-center ${
//             messageType === 'success'
//               ? 'bg-green-100 text-green-700'
//               : 'bg-red-100 text-red-700'
//           }`}
//         >
//           {message}
//         </div>
//       )}

//       <label
//         htmlFor="file-upload"
//         className="flex items-center justify-center border-2 border-dashed border-[#2dbfa8] rounded-lg p-6 cursor-pointer bg-[#2dbfa8] text-white hover:bg-[#25a895] transition"
//       >
//         <CloudUpload className="w-6 h-6 mr-2" />
//         <span>
//           {file ? file.name : 'Click to select a file (.xlsx or .xls)'}
//         </span>
//         <input
//           id="file-upload"
//           type="file"
//           accept=".xlsx,.xls"
//           onChange={handleFileChange}
//           className="hidden"
//         />
//       </label>

//       {file && (
//         <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border rounded-md">
//           <span className="text-sm text-gray-800 truncate">{file.name}</span>
//           <div className="flex gap-2">
//             <button
//               onClick={handleSubmit}
//               className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded-md text-sm transition"
//             >
//               Submit
//             </button>
//             <button
//               onClick={handleCancel}
//               className="bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded-md text-sm flex items-center gap-1 transition"
//             >
//               <XCircle className="w-4 h-4" />
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   </div>
// );

// };

// export default UploadExcel;
import React, { useState } from 'react';
import { CloudUpload, XCircle } from 'lucide-react';
import axios from 'axios';

const UploadExcel = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    setMessage('');
    setMessageType('');
  };

  const handleCancel = () => {
    setFile(null);
    setMessage('');
    setMessageType('');
  };

  const handleSubmit = async () => {
    if (!file) {
      setMessage('Please select a file first.');
      setMessageType('error');
      return;
    }

    const user = JSON.parse(localStorage.getItem('user'));
    const token = user?.token;

    if (!token) {
      setMessage('User not authenticated. Please login.');
      setMessageType('error');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}stock/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setMessage('File uploaded successfully.');
      setMessageType('success');
      setFile(null);
    } catch (err) {
      const serverMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        'Upload failed.';
      setMessage(serverMessage);
      setMessageType('error');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 py-12 sm:py-20">
      <div className="w-full max-w-lg bg-white shadow-xl rounded-2xl p-6 sm:p-10 border border-gray-200 space-y-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-blue-900">
          Upload Stock
        </h2>

        {message && (
          <div
            className={`p-3 rounded-md text-sm text-center transition-all duration-200 ${
              messageType === 'success'
                ? 'bg-green-100 text-green-700'
                : 'bg-red-100 text-red-700'
            }`}
          >
            {message}
          </div>
        )}

        {/* File Upload */}
        <label
          htmlFor="file-upload"
          className="flex flex-col sm:flex-row items-center justify-center gap-2 border-2 border-dashed border-[#2dbfa8] rounded-lg p-5 cursor-pointer bg-[#2dbfa8] text-white hover:bg-[#25a895] transition-all duration-200 text-center"
        >
          <CloudUpload className="w-6 h-6" />
          <span>
            {file ? file.name : 'Click to select a file (.xlsx or .xls)'}
          </span>
          <input
            id="file-upload"
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
            className="hidden"
          />
        </label>

        {/* Submit & Cancel */}
        {file && (
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 px-4 py-3 bg-gray-50 border rounded-md">
            <span className="text-sm text-gray-800 truncate w-full sm:w-auto text-center sm:text-left">
              {file.name}
            </span>
            <div className="flex gap-2 w-full sm:w-auto justify-center sm:justify-end">
              <button
                onClick={handleSubmit}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded-md text-sm transition"
              >
                Submit
              </button>
              <button
                onClick={handleCancel}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded-md text-sm flex items-center gap-1 transition"
              >
                <XCircle className="w-4 h-4" />
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadExcel;
